<div class="maindiv"> 
    <simple-datagrid entityName="Mktpshopee" [parentRow]="parentRow" [condition]="condition"></simple-datagrid>
</div>